import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${API_BASE}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getAdminToken = () => localStorage.getItem("ig_admin_token");
export const setAdminToken = (t) =>
  t ? localStorage.setItem("ig_admin_token", t) : localStorage.removeItem("ig_admin_token");

api.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiError(e, fallback = "Ops, algo deu errado. Tente de novo.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg ? x.msg : "")).filter(Boolean).join(" ") || fallback;
  return fallback;
}

export function trackEvent(type, data = {}) {
  api.post("/events", { type, ...data }).catch(() => {});
}

export function fmtBRL(v) {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function fmtPhone(digits) {
  if (!digits) return "—";
  const d = String(digits).replace(/\D/g, "");
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `+${d}`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
  } catch (e) {
    return iso;
  }
}

export const CLASSIFICATION_LABEL = { quente: "Quente", morno: "Morno", frio: "Frio", contato: "Contato" };
export const STATUS_LABEL = {
  novo: "Novo",
  contatado: "Contatado",
  em_negociacao: "Em negociação",
  fechado: "Fechado",
  perdido: "Perdido",
};

export function labelOf(v) {
  const map = {
    imovel: "Imóvel",
    veiculo: "Veículo",
    residencial: "Residencial",
    terreno: "Terreno",
    construcao_reforma: "Construção ou reforma",
    comercial: "Imóvel comercial",
    carro_novo: "Carro novo",
    carro_seminovo: "Carro seminovo",
    suv_utilitario: "SUV ou utilitário",
    nao: "Não",
    sim: "Sim",
    ate_10: "Até 10%",
    "10_30": "De 10% a 30%",
    mais_30: "Mais de 30%",
    ate_6: "Urgente: até 6 meses",
    "6_12": "De 6 a 12 meses",
    mais_12: "Mais de 12 meses",
    pesquisando: "Só pesquisando",
    um_pouco: "Sei um pouco",
  };
  return (v === null || v === undefined) ? "—" : map[v] || v;
}
